import React from 'react';
import { FormattedMessage } from 'react-intl';

import SelectCustom from '../../../SelectCustom';

const INPUT_WIDTH = 80;
const OPTIONS = [
  { value: 'true', label: <FormattedMessage id="common.yes" /> },
  { value: 'false', label: <FormattedMessage id="common.no" /> },
];

const SelectAnswer = ({ tempId, selectedValue, onChange }) => {
  const selected = selectedValue
    ? OPTIONS.find(opt => opt.value.toString() === selectedValue)
    : null;

  return (
    <SelectCustom
      options={OPTIONS}
      style={{ width: INPUT_WIDTH }}
      placeholder=""
      name={`${tempId}`}
      searchable={false}
      defaultValue={selected ? String(selected.value) : null}
      onChange={value => onChange(String(value.value))}
    />
  );
};

export default SelectAnswer;



// WEBPACK FOOTER //
// ./src/components/SequentialSurvey/Answers/SelectAnswer/index.jsx